"use client";
import { FourSquare } from "react-loading-indicators";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { useTheme } from "next-themes";

const Loading = () => {
    const { theme } = useTheme()
    return (
        <div
            className={`flex justify-center w-full items-center h-screen bg-response-container dark:bg-black-bg`}
        >
            <FourSquare
                color={` ${
                    theme === "light" ? " #f1f3fb" : "#181c21"
                } `}
                size="large"
                text=""
                textColor=""
            />
        </div>
    );
};
export default Loading;
